<script>
import FormDefault from "../Utils/Page/FormDefault";

export default {
    name: "EmailSubscriptionForm",
    mixins: [FormDefault],
    data() {
        return {
            lang: this.$ml.get('pages.email_subscriptions'),
            buttons: [],

            typeForm: {},

            form_required: [
                'email',
                'type'
            ],

            pageRouteList: 'email_subscriptions_list',
            pageRouteEdit: 'email_subscriptions_list.edit',
            pageApi: 'email_subscriptions',
        }
    }
}
</script>
